import React from "react";
import Nav from "../NavBar/index";
import { Layout } from "nq-component";

function NavBar(props) {
  const { collapsed, setCollapse } = React.useContext(Layout.Context);

  function onClickNavigate() {
    setCollapse(!collapsed);
  }

  return (
    <Nav
      className="shadow-sm"
      // title="DASHBOARD"
      onClickNavigate={onClickNavigate}
      {...props}
    />
  );
}

export default NavBar;
